<template>
  <div class="base-tooltip" v-if="showTooltip && !hiddenTooltip">
    <span
      class="base-tooltip__arrow"
      :class="[
        'base-tooltip__arrow-' + positionSide,
        'base-tooltip__arrow-' + positionClass,
        'base-tooltip__arrow-mobile',
      ]"
    ></span>
    <div class="base-tooltip__content">
      <div class="base-tooltip__content-close" @click="closeTooltip()">
        <base-icon
          style="margin: 0 auto"
          width="14"
          height="14"
          name="painel/close-icon"
        />
      </div>
      <div class="base-tooltip__description">
        <p class="base-tooltip__text">
          <strong v-html="title"></strong><br v-if="title" />
          <span v-html="description"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/* Configuration of width, height, position (top, right, left, bottom), 
are placed in the element that will render the tooltip, not here */

import WalletApi from '@/lib/api/Wallet'

export default {
  props: {
    showTooltip: {
      type: Boolean,
      default: false,
    },
    positionSide: {
      type: String,
      default: 'bottom',
    },
    position: {
      type: String,
      default: 'middle',
    },
    title: {
      type: String,
      require: true,
    },
    description: {
      type: String,
      require: true,
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    positionClass() {
      return this.positionSide == 'left' || this.positionSide == 'right'
        ? `vertical-${this.position}`
        : `horizontal-${this.position}`
    },
  },

  data() {
    return {
      hiddenTooltip: false,
    }
  },

  methods: {
    closeTooltip() {
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .setNotificationTooltipPixPresented()
        .catch(console.warn('Set Onboard presented failed'))
        .finally(() => {
          this.hiddenTooltip = true
        })
    },
  },
}
</script>

<style lang="scss">
.base-tooltip {
  padding: 20px;
  position: relative;
  width: fit-content;

  &__content {
    background-color: $gray-7;
    padding: 24px;
    max-width: 403px;
    border-radius: 8px;
    position: relative;

    &-close {
      margin: 4px 8px;
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  &__description {
    display: flex;
    color: #ffffff;

    svg {
      width: 40px;
      cursor: pointer;
    }
  }

  &__arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
  }

  &__arrow-left {
    border-color: transparent $gray-7 transparent transparent;
    border-width: 20px 20px 20px 0;
    left: 0px;
  }

  &__arrow-right {
    border-color: transparent transparent transparent $gray-7;
    border-width: 20px 0 20px 20px;
    right: 0px;
  }

  &__arrow-top {
    border-color: transparent transparent $gray-7 transparent;
    border-width: 0 20px 20px 20px;
    top: 0px;
  }

  &__arrow-bottom {
    border-color: $gray-7 transparent transparent transparent;
    border-width: 20px 20px 0 20px;
    bottom: 0px;
  }

  &__arrow-horizontal-start {
    left: 27px;
  }

  &__arrow-horizontal-middle {
    left: 50%;
    margin-left: -20px;
  }

  &__arrow-horizontal-bottom {
    right: 27px;
  }

  &__arrow-vertical-start {
    top: 27px;
  }

  &__arrow-vertical-middle {
    top: 50%;
    margin-top: -20px;
  }

  &__arrow-vertical-bottom {
    bottom: 27px;
  }

  &__text {
    font-size: 14px;
    color: #ffffff;

    strong {
      color: #ffffff;
    }

    span {
      opacity: 0.8;
    }
  }

  &__arrow-mobile {
    @media (max-width: 767px) {
      border-color: $gray-7 transparent transparent transparent;
      border-width: 20px 20px 0 20px;
      top: unset;
      right: unset;
      bottom: 0px;
      left: 50%;
      margin: 0 0 0 -20px;
    }
  }
}
</style>
